/**
 * Whether the comments system is closed.
 */
export const COMMENTS_CLOSED = true;
